import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from "vue";
import DatePicker from "@/components/picker/DatePicker.vue";
import { DateTime } from "luxon";
import { useConfirm } from "@/plugins/confirm/confirm";
import { useAlert } from "@/plugins/alert/alert";
import { useApi } from "@/plugins/api/api";

type Props = {
  userId: number;
};
type Emits = {
  (e: "retire"): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'UserRetireDialog',
  props: {
    userId: null
  },
  emits: ["retire"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "retire"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  userId: number;
};

const { $confirm } = useConfirm();
const { $alert } = useAlert();
const { Paths, $post } = useApi();




const isOpen = ref(false);
const date = ref(DateTime.now().toSQLDate());
const vform = ref();

const onClose = () => {
  isOpen.value = false;
};
const required = (val: unknown) => !!val || "必須入力です。";

watch(isOpen, val => {
  if (val) {
    date.value = DateTime.now().toSQLDate();
  }
});

const onRetire = async () => {
  const validate = vform.value?.validate();
  if (!validate) return;
  const confirm = await $confirm("退職にします。\nよろしいですか？");
  if (confirm) {
    const reuslt = await $post(
      `${Paths.userMaster.info.retire}/${props.userId}/${date.value}`
    );
    if (reuslt) {
      $alert("success", "退職にしました。");
      emits("retire");
    }
  }
};

return { __sfc: true,$confirm, $alert, Paths, $post, props, emits, isOpen, date, vform, onClose, required, onRetire, DatePicker }
}

})